import { Link } from "react-router-dom";
import { Archive, Search, ShieldCheck, BookOpen, Network, Sparkles } from "lucide-react";

const PILLARS = [
  { icon: Archive, title: "Preserve", body: "Photos, videos and photo sets uploaded by the community are stored, described and kept — so decades of gay kink & fetish culture don't vanish into dead links and lost drives." },
  { icon: BookOpen, title: "Remember", body: "The Stories archive keeps erotic fiction and lived histories readable — .txt, .pdf, .docx and web pages parsed, scanned and safely shelved alongside the images." },
  { icon: Network, title: "Understand", body: "The KinkVault Semantic Index reads every upload with evidence-weighted AI — building an ontology of materials, gear, bodies and scenes instead of shallow, hallucinated tags." },
  { icon: Search, title: "Discover", body: "Hybrid semantic + concept search and a personalized For You feed help you find exactly what you're into, and stumble onto history you never knew existed." },
];

export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-16 pb-20" data-testid="about-page">
      <title>About · KinkVault — a living archive of queer erotic history</title>

      <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-[#00E5FF] mb-3">Explicit content · 18+ · community archive</p>
      <h1 className="font-heading text-4xl sm:text-6xl uppercase tracking-tighter text-white leading-[0.95] mb-5">
        A living archive of<br /><span className="bg-gradient-to-r from-[#0066FF] to-[#00E5FF] bg-clip-text text-transparent">queer erotic history</span>
      </h1>
      <p className="text-[#D4D4D8] text-base leading-relaxed mb-4">
        KinkVault is not just another porn site. It's a community-built <strong className="text-white">archive</strong> for gay kink and
        fetish culture — the images, films, gear, rituals and stories that generations of queer men made, wore and passed
        around. So much of it lives on dying platforms, deleted accounts and forgotten hard drives. This is where it's kept.
      </p>
      <p className="text-[#A1A1AA] text-base leading-relaxed mb-10">
        Everything here is uploaded by members, described and organized by our Semantic Index, and made searchable for the
        people who care about it. <span className="text-[#00E5FF]">Preservation, not just consumption.</span>
      </p>

      <div className="grid sm:grid-cols-2 gap-4 mb-12">
        {PILLARS.map((p) => (
          <div key={p.title} className="bg-[#0A0A0A] border border-white/[0.06] rounded-2xl p-5" data-testid={`about-pillar-${p.title.toLowerCase()}`}>
            <span className="w-10 h-10 rounded-xl flex items-center justify-center bg-[#00E5FF]/12 border border-[#00E5FF]/25 mb-3"><p.icon size={19} className="text-[#00E5FF]" /></span>
            <h2 className="text-white font-heading uppercase tracking-tight text-lg mb-1">{p.title}</h2>
            <p className="text-[#A1A1AA] text-sm leading-relaxed">{p.body}</p>
          </div>
        ))}
      </div>

      <div className="bg-[#0A0A0A] border border-white/[0.06] rounded-2xl p-5 mb-12 flex gap-3" data-testid="about-consent">
        <ShieldCheck size={20} className="text-[#31A24C] shrink-0 mt-0.5" />
        <div>
          <h2 className="text-white font-heading uppercase tracking-tight text-sm mb-1">Adults, consent &amp; care</h2>
          <p className="text-[#A1A1AA] text-sm leading-relaxed">
            KinkVault is strictly for adults (18+ or the legal age in your jurisdiction). Uploads are AI-screened for
            underage or non-consensual material and flagged for human review. This is a space built on consent, community and respect.
          </p>
        </div>
      </div>

      <div className="text-center">
        <Link to="/register" data-testid="about-join-btn" className="inline-flex items-center gap-2 px-7 py-3 rounded-xl bg-[#00E5FF] text-black font-heading uppercase tracking-[0.2em] text-sm hover:bg-[#00c9e0] transition-colors shadow-[0_0_18px_rgba(0,229,255,0.35)]">
          <Sparkles size={16} /> Join the archive
        </Link>
        <p className="text-[#52525B] font-mono text-[11px] mt-4">Already a member? <Link to="/login" className="text-[#00E5FF] hover:underline">Log in</Link></p>
      </div>
    </div>
  );
}
